import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAnalytics from './analytics.reducer';

export const selectAnalyticsState = createFeatureSelector<fromAnalytics.State>(
  fromAnalytics.analyticsFeatureKey
);

export const selectAdobeAnalyticsLoaded = createSelector(
  selectAnalyticsState,
  (state: fromAnalytics.State) => state.adobeAnalyticsLoaded
);

export const selectGoogleAnalyticsLoaded = createSelector(
  selectAnalyticsState,
  (state: fromAnalytics.State) => state.googleAnalyticsLoaded
);

export const selectGtm = createSelector(
  selectAnalyticsState,
  (state: fromAnalytics.State) => state.gtm
);

export const selectUser = createSelector(
  selectAnalyticsState,
  (state: fromAnalytics.State) => state.user
);
